import type { PaymentFormTokenResponse } from './payment-method-form.tsx';

/** Finix Payment Form submit responses may include a provider error message when submit fails. */
export const finixPaymentFormErrorMessage = (
  response: PaymentFormTokenResponse | undefined,
): string | undefined => {
  const message = response?.data._embedded?.errors[0]?.message;

  if (message == null || message === '') {
    return undefined;
  }

  return message;
};
